<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    showNewTag: {
      type: Boolean,
      default: false
    }
  },
  render(h, context) {
    const { icon, title, showNewTag } = context.props
    const vnodes = []

    if (icon) {
      vnodes.push(<svg-icon icon-class={icon}/>)
    }
    let menuClass = ['item-menu']
    showNewTag && menuClass.push('menu-new')
    if (title) {
      vnodes.push(<span slot='title' class={(menuClass.join(' '))}>{(title)}</span>)
    }
    return vnodes
  }
}
</script>

<style lang="scss" scoped>
.menu-new {
    position: relative;
    &::after {
      // content: " New";
      font-size: 13px;
      font-weight: bold;
      font-style: italic;
      opacity: 999;
      margin-top: -5px;
      margin-left: 5px;
      position: absolute;
      animation: menu-new-animation .5s infinite;
      -webkit-animation: menu-new-animation .5s infinite; /* Safari 与 Chrome */
    }
  }
  /* 设置动画 */
  @keyframes menu-new-animation {
    from {
      color: #fff;
    }
    to {
      color: gold;
    }
  }
</style>
